import React from 'react';
const STEPS = [{
  title: 'Заявка и онлайн-консультация',
  desc: 'Заполняете короткую форму и прикрепляете снимки. Павел Петрович лично изучит ваш случай и расскажет, подходит ли вам операция.'
}, {
  title: 'Подготовка документов',
  desc: 'С вами работает — ваш персональный ассистент. Она оформляет документы для госпитализации, отвечает на все организационные вопросы. Вам не нужно разбираться в системе самостоятельно.'
}, {
  title: 'Приезд в Петербург и операция',
  desc: 'Операция проходит в ведущем ортопедическом центре Санкт-Петербурга. Нахождение в стационаре 4-5 дней.'
}, {
  title: 'Быстрая активизация',
  desc: 'Первые шаги уже на следующий день после операции с применением дополнительных средств опоры.'
}, {
  title: 'Сопровождение после выписки',
  desc: 'Остаёмся на связи: контрольные снимки, рекомендации по реабилитации, ответы на вопросы.'
}];
export function TreatmentTimeline() {
  return <section className="w-full bg-slate-50" data-id="element-99">
      <div className="mx-auto max-w-3xl px-5 py-14 sm:px-6 lg:py-20" data-id="element-100">
        <h2 className="text-xl font-semibold tracking-tight text-slate-900 sm:text-2xl lg:text-3xl" data-id="element-101">
          Как проходит лечение
        </h2>

        <ol className="mt-10 space-y-0" data-id="element-102">
          {STEPS.map((step, index) => <li key={step.title} className="relative flex gap-5 pb-10 last:pb-0" data-id="element-103">
              <div className="flex flex-col items-center" data-id="element-104">
                <span className="flex h-11 w-11 flex-shrink-0 items-center justify-center rounded-full bg-blue-600 text-lg font-semibold text-white" data-id="element-105">
                  {index + 1}
                </span>
                {index < STEPS.length - 1 && <span className="mt-2 w-0.5 flex-1 bg-blue-200" aria-hidden="true" data-id="element-106" />}
              </div>
              <div className="pt-1.5" data-id="element-107">
                <h3 className="text-lg font-semibold text-slate-900 sm:text-xl" data-id="element-108">
                  {step.title}
                </h3>
                <p className="mt-2 text-lg leading-relaxed text-slate-600" data-id="element-109">
                  {step.desc}
                </p>
              </div>
            </li>)}
        </ol>
      </div>
    </section>;
}